import VehiclesList from '../../components/vehicles/VehiclesList'
import { connect } from 'react-redux'
import { IStoreState, IVehicleFilters } from '../../types'
import { actionCreators } from '../../state/actions/vehicles/index'
import { getVehicles } from '../../state/actions/vehicles/'

export function mapStateToProps(state: IStoreState) {
  const currentOrgId: string = state.organizations.currentOrgId as string
  return {
    currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    // fetchAllVehicles: (type: string) => {
    //   dispatch(getVehicles(type))
    // },
    updateVehicleFilters: (params: IVehicleFilters) => dispatch(actionCreators.updateVehicleFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehiclesList)



// WEBPACK FOOTER //
// ./src/containers/vehicles/VehiclesList.ts